// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
}

:host(.post-updates-host--hidden) {
  display: none !important;
}

.post-updates {
  padding: 16px 20px 20px;
}
.post-updates__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eef2f7;
}
.post-updates__title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.post-updates__title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}
.post-updates__count {
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.post-updates__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.post-updates__form .label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}
.post-updates__form .post-update-required {
  display: inline;
  margin-left: 2px;
  color: #dc2626;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}
.post-updates__form .invalid-feedback {
  margin-top: 4px;
  font-size: 12px;
}
.post-updates__form .form-control.is-invalid,
.post-updates__form .searchable-select__input.is-invalid {
  border-color: #dc3545;
  box-shadow: none;
}
.post-updates__form .form-control.is-invalid:focus,
.post-updates__form .searchable-select__input.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.2);
}
.post-updates__form .form-group {
  margin-bottom: 14px;
}
.post-updates__form-actions {
  display: flex;
  gap: 8px;
}
.post-updates__timeline {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.post-updates__empty {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}
.post-updates__item {
  position: relative;
  padding: 14px 16px 14px 18px;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  background: #fff;
  border-left: 3px solid #94a3b8;
}
.post-updates__item.priority-low {
  border-left-color: #22c55e;
}
.post-updates__item.priority-medium {
  border-left-color: #eab308;
}
.post-updates__item.priority-high, .post-updates__item.priority-critical {
  border-left-color: #ef4444;
}
.post-updates__item-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.post-updates__item-date {
  color: #0f172a;
  font-size: 14px;
}
.post-updates__item-meta {
  margin-top: 4px;
  color: #64748b;
}
.post-updates__item-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.post-updates__item-body {
  margin: 10px 0 0;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.55;
  white-space: pre-wrap;
}
.post-updates__evidence-list {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.evidence-block {
  margin: 2px 0 12px;
  padding-top: 12px;
  border-top: 1px solid #e8edf3;
}
.evidence-block__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}
.evidence-block__title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.evidence-block__count {
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.evidence-block__empty {
  padding: 10px 12px;
  background: #fff;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #64748b;
  font-size: 13px;
}
.evidence-block__limit {
  margin: 8px 0 0;
  color: #b45309;
  font-size: 12px;
}

.evidence-table {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.evidence-table__head, .evidence-table__row {
  display: grid;
  grid-template-columns: 36px minmax(0, 1.35fr) minmax(150px, 1fr) 132px 34px;
  gap: 8px;
  align-items: center;
  padding: 0 10px;
}
.evidence-table__head {
  min-height: 32px;
  background: #f8fafc;
  border-bottom: 1px solid #eef2f7;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.evidence-table__row {
  min-height: 48px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.12s ease;
}
.evidence-table__row:last-of-type {
  border-bottom: 0;
}
.evidence-table__row:hover {
  background: #fbfdff;
}
.evidence-table__col {
  min-width: 0;
}
.evidence-table__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}
.evidence-table__mobile-label {
  display: none;
}
.evidence-table__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
}
.evidence-table__remove:hover {
  background: #fee2e2;
  color: #b91c1c;
}
.evidence-table__col--action {
  display: flex;
  justify-content: center;
}
.evidence-table__foot {
  margin: 0;
  padding: 6px 10px 8px;
  border-top: 1px solid #f1f5f9;
  background: #fafbfc;
  color: #94a3b8;
  font-size: 11px;
}
.evidence-table .form-control-sm {
  height: 32px;
  font-size: 13px;
  border-color: #e2e8f0;
  border-radius: 6px;
}
.evidence-table .form-control-sm:focus {
  border-color: #93c5fd;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.evidence-attach {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-height: 32px;
  min-width: 0;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}
.evidence-attach.is-invalid {
  border-color: #dc3545;
}
.evidence-attach--pick {
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  transition: border-color 0.12s ease, background 0.12s ease, color 0.12s ease;
}
.evidence-attach--pick:hover {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}
.evidence-attach--on {
  padding-right: 4px;
  background: #fff;
}
.evidence-attach__status {
  font-size: 12px;
  color: #64748b;
}
.evidence-attach__name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  color: #0f172a;
  text-decoration: none;
}
.evidence-attach__name:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.evidence-attach__action {
  position: relative;
  flex-shrink: 0;
  margin: 0;
  padding: 2px 6px;
  border-radius: 4px;
  color: #2563eb;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.evidence-attach__action:hover {
  background: #eff6ff;
}
.evidence-attach__clear {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
}
.evidence-attach__clear:hover {
  background: #fee2e2;
  color: #b91c1c;
}

@media (max-width: 767px) {
  .evidence-table__head {
    display: none;
  }
  .evidence-table__row {
    grid-template-columns: 28px 1fr 28px;
    grid-template-areas: "num link action" "num file action" "num date action";
    gap: 6px 8px;
    align-items: start;
    padding: 10px;
  }
  .evidence-table__col--num {
    grid-area: num;
    padding-top: 6px;
  }
  .evidence-table__col--link {
    grid-area: link;
  }
  .evidence-table__col--file {
    grid-area: file;
  }
  .evidence-table__col--date {
    grid-area: date;
  }
  .evidence-table__col--action {
    grid-area: action;
    padding-top: 2px;
    align-items: flex-start;
  }
  .evidence-table__mobile-label {
    display: block;
    margin-bottom: 3px;
    color: #94a3b8;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
}
.evidence-file__input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.evidence-file__badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.2;
  background: #e2e8f0;
  color: #334155;
}
.evidence-file__badge--pdf {
  background: #fee2e2;
  color: #b91c1c;
}
.evidence-file__badge--img {
  background: #dbeafe;
  color: #1d4ed8;
}
.evidence-file__badge--url {
  background: #ecfdf5;
  color: #047857;
}
.evidence-file__badge--file {
  background: #e2e8f0;
  color: #334155;
}

.evidence-chip {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  background: #f8fafc;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  font-size: 13px;
  overflow: hidden;
}
.evidence-chip__rows {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.evidence-chip__row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  min-width: 0;
}
.evidence-chip__row + .evidence-chip__row {
  border-top: 1px solid #eef2f7;
}
.evidence-chip__link {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0f172a;
  font-weight: 500;
  line-height: 1.3;
}
.evidence-chip__link:hover {
  color: #1d4ed8;
}
.evidence-chip__link--muted {
  color: #64748b;
  font-weight: 400;
}
.evidence-chip__action {
  flex-shrink: 0;
  margin: 0;
  padding: 4px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: #1e40af;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
}
.evidence-chip__action:hover {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}
.evidence-chip__meta {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-top: 1px solid #eef2f7;
  background: #f1f5f9;
}
.evidence-chip__reviewed {
  color: #64748b;
  font-size: 12px;
  line-height: 1.3;
}

.badge-published {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  vertical-align: middle;
}

.priority-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  vertical-align: middle;
}
.priority-badge--preview {
  margin-top: 8px;
}
.priority-badge.priority-low {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}
.priority-badge.priority-medium {
  background: #fef9c3;
  color: #854d0e;
  border: 1px solid #fde047;
}
.priority-badge.priority-high, .priority-badge.priority-critical {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.word-wrap {
  word-break: break-word;
}

/* Same pattern as root report: switch + status on one row.
   Must be top-level — the form lives in an Ngb modal, outside .post-updates. */
.publish-control {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  min-height: 38px;
}
.publish-control .custom-control {
  display: inline-flex;
  width: auto;
  flex: 0 0 auto;
  margin-right: 0;
}
.publish-control .custom-control-label {
  width: auto;
}

.publish-hint {
  flex: 0 0 auto;
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
}

.publish-root-hint {
  margin: 4px 0 0;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.35;
}

.post-update-modal__header {
  border-bottom: 1px solid #eef2f7;
}
.post-update-modal__header .modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}
.post-update-modal__body {
  padding: 16px 20px;
  background: #fff;
}
.post-update-modal__footer {
  border-top: 1px solid #eef2f7;
  gap: 8px;
}

::ng-deep .post-update-form-modal .modal-dialog {
  max-width: 640px;
  width: calc(100% - 1.5rem);
  margin: 1rem auto;
}
::ng-deep .post-update-form-modal .modal-content {
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-updates/post-updates.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACJ;AAEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAAJ;AAGE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFJ;AAMI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAJN;AAOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALN;AAQI;EACE,eAAA;EACA,eAAA;AANN;AASI;;EAEE,qBAAA;EACA,gBAAA;AAPN;AASM;;EACE,qBAAA;EACA,+CAAA;AANR;AAUI;EACE,mBAAA;AARN;AAYE;EACE,aAAA;EACA,QAAA;AAVJ;AAaE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAXJ;AAcE;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAZJ;AAeE;EACE,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AAbJ;AAeI;EACE,0BAAA;AAbN;AAgBI;EACE,0BAAA;AAdN;AAiBI;EAEE,0BAAA;AAhBN;AAoBE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,eAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,cAAA;AApBJ;AAuBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AArBJ;AAwBE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAtBJ;AAyBE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAvBJ;;AA2BA;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;AAxBF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA3BJ;AA8BE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA5BJ;;AAgCA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA7BF;AA+BE;EAEE,aAAA;EACA,2EAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AA9BJ;AAiCE;EACE,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA/BJ;AAkCE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,iCAAA;AAhCJ;AAkCI;EACE,gBAAA;AAhCN;AAmCI;EACE,mBAAA;AAjCN;AAqCE;EACE,YAAA;AAnCJ;AAsCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,aAAA;AArCJ;AAwCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mDAAA;AAtCJ;AAwCI;EACE,mBAAA;EACA,cAAA;AAtCN;AA0CE;EACE,aAAA;EACA,uBAAA;AAxCJ;AA2CE;EACE,SAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAzCJ;AA4CE;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AA1CJ;AA4CI;EACE,qBAAA;EACA,8CAAA;AA1CN;;AA+CA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AA5CF;AA8CE;EACE,qBAAA;AA5CJ;AA+CE;EACE,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,4EAAA;AA7CJ;AA+CI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA7CN;AAiDE;EACE,kBAAA;EACA,gBAAA;AA/CJ;AAkDE;EACE,eAAA;EACA,cAAA;AAhDJ;AAmDE;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAjDJ;AAmDI;EACE,cAAA;EACA,0BAAA;AAjDN;AAqDE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAnDJ;AAqDI;EACE,mBAAA;AAnDN;AAuDE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AArDJ;AAuDI;EACE,mBAAA;EACA,cAAA;AArDN;;AA0DA;EAEI;IACE,aAAA;EAxDJ;EA2DE;IACE,oCAAA;IACA,0EACE;IAGF,YAAA;IACA,kBAAA;IACA,aAAA;EA5DJ;EA+DE;IACE,cAAA;IACA,gBAAA;EA7DJ;EAgEE;IACE,eAAA;EA9DJ;EAiEE;IACE,eAAA;EA/DJ;EAkEE;IACE,eAAA;EAhEJ;EAmEE;IACE,iBAAA;IACA,gBAAA;IACA,uBAAA;EAjEJ;EAoEE;IACE,cAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,yBAAA;EAlEJ;AACF;AAuEE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AArEJ;AAwEE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAtEJ;AAwEI;EACE,mBAAA;EACA,cAAA;AAtEN;AAyEI;EACE,mBAAA;EACA,cAAA;AAvEN;AA0EI;EACE,mBAAA;EACA,cAAA;AAxEN;AA2EI;EACE,mBAAA;EACA,cAAA;AAzEN;;AA8EA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA3EF;AA6EE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AA3EJ;AA8EE;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AA5EJ;AA8EI;EACE,6BAAA;AA5EN;AAgFE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA9EJ;AAgFI;EACE,cAAA;AA9EN;AAiFI;EACE,cAAA;EACA,gBAAA;AA/EN;AAmFE;EACE,cAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAjFJ;AAmFI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjFN;AAqFE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;AAnFJ;AAsFE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AApFJ;;AAwFA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AArFF;;AAwFA;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AArFF;AAuFE;EACE,eAAA;AArFJ;AAwFE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAtFJ;AAyFE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAvFJ;AA0FE;EAEE,mBAAA;EACA,cAAA;EACA,yBAAA;AAzFJ;;AA6FA;EACE,sBAAA;AA1FF;;AA6FA;+EAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;AA1FF;AA4FE;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AA1FJ;AA6FE;EACE,WAAA;AA3FJ;;AA+FA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA5FF;;AA+FA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA5FF;;AAgGE;EACE,gCAAA;AA7FJ;AA+FI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA7FN;AAiGE;EACE,kBAAA;EACA,gBAAA;AA/FJ;AAkGE;EACE,6BAAA;EACA,QAAA;AAhGJ;;AAqGE;EACE,gBAAA;EACA,0BAAA;EACA,iBAAA;AAlGJ;AAqGE;EACE,mBAAA;AAnGJ","sourcesContent":[":host {\n  display: block;\n}\n\n:host(.post-updates-host--hidden) {\n  display: none !important;\n}\n\n.post-updates {\n  padding: 16px 20px 20px;\n\n  &__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding-bottom: 12px;\n    margin-bottom: 16px;\n    border-bottom: 1px solid #eef2f7;\n  }\n\n  &__title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #64748b;\n  }\n\n  &__count {\n    min-width: 22px;\n    height: 22px;\n    padding: 0 6px;\n    border-radius: 999px;\n    background: #eef2f7;\n    color: #475569;\n    font-size: 12px;\n    font-weight: 700;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__form {\n    .label {\n      font-size: 12px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n      color: #64748b;\n    }\n\n    .post-update-required {\n      display: inline;\n      margin-left: 2px;\n      color: #dc2626;\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 1;\n    }\n\n    .invalid-feedback {\n      margin-top: 4px;\n      font-size: 12px;\n    }\n\n    .form-control.is-invalid,\n    .searchable-select__input.is-invalid {\n      border-color: #dc3545;\n      box-shadow: none;\n\n      &:focus {\n        border-color: #dc3545;\n        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.2);\n      }\n    }\n\n    .form-group {\n      margin-bottom: 14px;\n    }\n  }\n\n  &__form-actions {\n    display: flex;\n    gap: 8px;\n  }\n\n  &__timeline {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__empty {\n    margin: 0;\n    color: #64748b;\n    font-size: 14px;\n  }\n\n  &__item {\n    position: relative;\n    padding: 14px 16px 14px 18px;\n    border: 1px solid #e8edf3;\n    border-radius: 8px;\n    background: #fff;\n    border-left: 3px solid #94a3b8;\n\n    &.priority-low {\n      border-left-color: #22c55e;\n    }\n\n    &.priority-medium {\n      border-left-color: #eab308;\n    }\n\n    &.priority-high,\n    &.priority-critical {\n      border-left-color: #ef4444;\n    }\n  }\n\n  &__item-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  &__item-date {\n    color: #0f172a;\n    font-size: 14px;\n  }\n\n  &__item-meta {\n    margin-top: 4px;\n    color: #64748b;\n  }\n\n  &__item-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  &__item-body {\n    margin: 10px 0 0;\n    color: #1f2937;\n    font-size: 14px;\n    line-height: 1.55;\n    white-space: pre-wrap;\n  }\n\n  &__evidence-list {\n    list-style: none;\n    margin: 12px 0 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n.evidence-block {\n  margin: 2px 0 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e8edf3;\n\n  &__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 8px;\n  }\n\n  &__title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  &__count {\n    min-width: 20px;\n    height: 20px;\n    padding: 0 5px;\n    border-radius: 999px;\n    background: #e2e8f0;\n    color: #334155;\n    font-size: 11px;\n    font-weight: 700;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__empty {\n    padding: 10px 12px;\n    background: #fff;\n    border: 1px dashed #cbd5e1;\n    border-radius: 8px;\n    color: #64748b;\n    font-size: 13px;\n  }\n\n  &__limit {\n    margin: 8px 0 0;\n    color: #b45309;\n    font-size: 12px;\n  }\n}\n\n.evidence-table {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n\n  &__head,\n  &__row {\n    display: grid;\n    grid-template-columns: 36px minmax(0, 1.35fr) minmax(150px, 1fr) 132px 34px;\n    gap: 8px;\n    align-items: center;\n    padding: 0 10px;\n  }\n\n  &__head {\n    min-height: 32px;\n    background: #f8fafc;\n    border-bottom: 1px solid #eef2f7;\n    color: #94a3b8;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n  }\n\n  &__row {\n    min-height: 48px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.12s ease;\n\n    &:last-of-type {\n      border-bottom: 0;\n    }\n\n    &:hover {\n      background: #fbfdff;\n    }\n  }\n\n  &__col {\n    min-width: 0;\n  }\n\n  &__num {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border-radius: 999px;\n    background: #f1f5f9;\n    color: #64748b;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  &__mobile-label {\n    display: none;\n  }\n\n  &__remove {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: #94a3b8;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.12s ease, color 0.12s ease;\n\n    &:hover {\n      background: #fee2e2;\n      color: #b91c1c;\n    }\n  }\n\n  &__col--action {\n    display: flex;\n    justify-content: center;\n  }\n\n  &__foot {\n    margin: 0;\n    padding: 6px 10px 8px;\n    border-top: 1px solid #f1f5f9;\n    background: #fafbfc;\n    color: #94a3b8;\n    font-size: 11px;\n  }\n\n  .form-control-sm {\n    height: 32px;\n    font-size: 13px;\n    border-color: #e2e8f0;\n    border-radius: 6px;\n\n    &:focus {\n      border-color: #93c5fd;\n      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n    }\n  }\n}\n\n.evidence-attach {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  min-height: 32px;\n  min-width: 0;\n  padding: 0 8px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n\n  &.is-invalid {\n    border-color: #dc3545;\n  }\n\n  &--pick {\n    justify-content: center;\n    gap: 6px;\n    cursor: pointer;\n    color: #334155;\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0;\n    transition: border-color 0.12s ease, background 0.12s ease, color 0.12s ease;\n\n    &:hover {\n      background: #eff6ff;\n      border-color: #93c5fd;\n      color: #1d4ed8;\n    }\n  }\n\n  &--on {\n    padding-right: 4px;\n    background: #fff;\n  }\n\n  &__status {\n    font-size: 12px;\n    color: #64748b;\n  }\n\n  &__name {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    font-weight: 500;\n    color: #0f172a;\n    text-decoration: none;\n\n    &:hover {\n      color: #1d4ed8;\n      text-decoration: underline;\n    }\n  }\n\n  &__action {\n    position: relative;\n    flex-shrink: 0;\n    margin: 0;\n    padding: 2px 6px;\n    border-radius: 4px;\n    color: #2563eb;\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n\n    &:hover {\n      background: #eff6ff;\n    }\n  }\n\n  &__clear {\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 4px;\n    background: transparent;\n    color: #94a3b8;\n    font-size: 14px;\n    line-height: 1;\n    cursor: pointer;\n\n    &:hover {\n      background: #fee2e2;\n      color: #b91c1c;\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .evidence-table {\n    &__head {\n      display: none;\n    }\n\n    &__row {\n      grid-template-columns: 28px 1fr 28px;\n      grid-template-areas:\n        'num link action'\n        'num file action'\n        'num date action';\n      gap: 6px 8px;\n      align-items: start;\n      padding: 10px;\n    }\n\n    &__col--num {\n      grid-area: num;\n      padding-top: 6px;\n    }\n\n    &__col--link {\n      grid-area: link;\n    }\n\n    &__col--file {\n      grid-area: file;\n    }\n\n    &__col--date {\n      grid-area: date;\n    }\n\n    &__col--action {\n      grid-area: action;\n      padding-top: 2px;\n      align-items: flex-start;\n    }\n\n    &__mobile-label {\n      display: block;\n      margin-bottom: 3px;\n      color: #94a3b8;\n      font-size: 10px;\n      font-weight: 700;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.evidence-file {\n  &__input {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  &__badge {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 30px;\n    padding: 1px 5px;\n    border-radius: 4px;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    line-height: 1.2;\n    background: #e2e8f0;\n    color: #334155;\n\n    &--pdf {\n      background: #fee2e2;\n      color: #b91c1c;\n    }\n\n    &--img {\n      background: #dbeafe;\n      color: #1d4ed8;\n    }\n\n    &--url {\n      background: #ecfdf5;\n      color: #047857;\n    }\n\n    &--file {\n      background: #e2e8f0;\n      color: #334155;\n    }\n  }\n}\n\n.evidence-chip {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  background: #f8fafc;\n  border: 1px solid #e8edf3;\n  border-radius: 8px;\n  font-size: 13px;\n  overflow: hidden;\n\n  &__rows {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  &__row {\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    min-width: 0;\n\n    & + & {\n      border-top: 1px solid #eef2f7;\n    }\n  }\n\n  &__link {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #0f172a;\n    font-weight: 500;\n    line-height: 1.3;\n\n    &:hover {\n      color: #1d4ed8;\n    }\n\n    &--muted {\n      color: #64748b;\n      font-weight: 400;\n    }\n  }\n\n  &__action {\n    flex-shrink: 0;\n    margin: 0;\n    padding: 4px 10px;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    background: #fff;\n    color: #1e40af;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.2;\n    white-space: nowrap;\n    cursor: pointer;\n\n    &:hover {\n      background: #eff6ff;\n      border-color: #93c5fd;\n      color: #1d4ed8;\n    }\n  }\n\n  &__meta {\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    border-top: 1px solid #eef2f7;\n    background: #f1f5f9;\n  }\n\n  &__reviewed {\n    color: #64748b;\n    font-size: 12px;\n    line-height: 1.3;\n  }\n}\n\n.badge-published {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #a7f3d0;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  vertical-align: middle;\n}\n\n.priority-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  vertical-align: middle;\n\n  &--preview {\n    margin-top: 8px;\n  }\n\n  &.priority-low {\n    background: #dcfce7;\n    color: #166534;\n    border: 1px solid #86efac;\n  }\n\n  &.priority-medium {\n    background: #fef9c3;\n    color: #854d0e;\n    border: 1px solid #fde047;\n  }\n\n  &.priority-high,\n  &.priority-critical {\n    background: #fee2e2;\n    color: #b91c1c;\n    border: 1px solid #fca5a5;\n  }\n}\n\n.word-wrap {\n  word-break: break-word;\n}\n\n/* Same pattern as root report: switch + status on one row.\n   Must be top-level — the form lives in an Ngb modal, outside .post-updates. */\n.publish-control {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 10px;\n  min-height: 38px;\n\n  .custom-control {\n    display: inline-flex;\n    width: auto;\n    flex: 0 0 auto;\n    margin-right: 0;\n  }\n\n  .custom-control-label {\n    width: auto;\n  }\n}\n\n.publish-hint {\n  flex: 0 0 auto;\n  font-size: 13px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.publish-root-hint {\n  margin: 4px 0 0;\n  color: #94a3b8;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.post-update-modal {\n  &__header {\n    border-bottom: 1px solid #eef2f7;\n\n    .modal-title {\n      font-size: 15px;\n      font-weight: 700;\n      color: #0f172a;\n    }\n  }\n\n  &__body {\n    padding: 16px 20px;\n    background: #fff;\n  }\n\n  &__footer {\n    border-top: 1px solid #eef2f7;\n    gap: 8px;\n  }\n}\n\n::ng-deep .post-update-form-modal {\n  .modal-dialog {\n    max-width: 640px;\n    width: calc(100% - 1.5rem);\n    margin: 1rem auto;\n  }\n\n  .modal-content {\n    border-radius: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
